import { useEffect, useRef, useState } from 'react';
import getLineCount from '../../../helpers/utils/getLineCount';

const ShowMoreContent = ({ showLessTextLine = 2, desc }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const textRef = useRef(null);
  const containerRef = useRef(null);

  const updateTextContainer = () => {
    const element = textRef.current;
    if (!element) return;

    // Hapus sementara line-clamp untuk menghitung line count dengan akurat
    const originalClassName = element.className;
    element.className = originalClassName.replace(/line-clamp-\d+/g, 'line-clamp-none');

    const lineCount = getLineCount(element);

    // Kembalikan kelas asli setelah perhitungan
    element.className = originalClassName;
    if (lineCount > showLessTextLine) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  // Toggle expand/collapse of text
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    updateTextContainer();
    window.addEventListener('resize', updateTextContainer);
    return () => window.removeEventListener('resize', updateTextContainer);
  }, [showLessTextLine]);

  return (
    <>
      <div ref={containerRef} className="text-container">
        <div
          id="text-ref"
          ref={textRef}
          className={`text-xs font-normal !leading-relaxed text-reliableBlack lg:text-sm lg:text-reliableBlack90 ${!isExpanded && showButton ? `line-clamp-${showLessTextLine}` : 'line-clamp-none'} `}
          dangerouslySetInnerHTML={{
            __html: desc,
          }}
        />
      </div>
      <div className="text-left">
        {showButton && (
          <button
            className="block text-xs font-medium text-hyperLink uppercase"
            onClick={toggleExpand}
          >
            {isExpanded ? 'LIHAT LEBIH SEDIKIT' : 'LIHAT SELENGKAPNYA'}
          </button>
        )}
      </div>
    </>
  );
};

export default ShowMoreContent;
